// pages/unauthorized/UnauthorizedPage.js
import React from 'react';
import { Link } from 'react-router';

const UnauthorizedPage = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <h1 className="text-2xl font-bold mb-4">Unauthorized Access</h1>
      <p className="mb-4">You don't have permission to access this page.</p>
      <Link 
        to="/" 
        className="text-blue-500 hover:text-blue-700"
      >
        Return to Dashboard
      </Link>
    </div>
  );
};

export default UnauthorizedPage;